var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSkincare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 9.46428C5.49309 9.46428 5.89283 9.06454 5.89283 8.57143C5.89283 8.07832 5.49309 7.67857 4.99997 7.67857C4.50686 7.67857 4.10712 8.07832 4.10712 8.57143C4.10712 9.06454 4.50686 9.46428 4.99997 9.46428Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4071 5.41429L12.75 6.85C12.8143 7.17857 12.8571 7.51429 12.8571 7.85714C12.8571 11.0071 10.2929 13.5714 7.14286 13.5714C3.99286 13.5714 1.42857 11.0071 1.42857 7.85714C1.42857 7.82143 1.43571 7.78572 1.42857 7.75714C3.28571 7.05714 4.77857 5.62143 5.52857 3.79286C6.84286 5.4 8.83571 6.42857 11.0714 6.42857C11.3929 6.42857 11.7071 6.4 12.0214 6.35714L11.5929 5.41429L10.9643 4.03572L9.58571 3.40714L7.59286 2.5L9.58571 1.59286L10.0929 1.36429C9.19286 0.950001 8.19286 0.714287 7.14286 0.714287C3.2 0.714287 0 3.91429 0 7.85714C0 11.8 3.2 15 7.14286 15C11.0857 15 14.2857 11.8 14.2857 7.85714C14.2857 6.80714 14.05 5.80714 13.6429 4.90714L13.4071 5.41429V5.41429Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28574 9.46428C9.77885 9.46428 10.1786 9.06454 10.1786 8.57143C10.1786 8.07832 9.77885 7.67857 9.28574 7.67857C8.79263 7.67857 8.39288 8.07832 8.39288 8.57143C8.39288 9.06454 8.79263 9.46428 9.28574 9.46428Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2857 3.28571L12.5 5L11.7143 3.28571L10 2.5L11.7143 1.71429L12.5 0L13.2857 1.71429L15 2.5L13.2857 3.28571Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSkincare);
export default __webpack_public_path__ + "static/media/ic-skincare.d23d77544e64548f2591a8209db1f6cc.svg";
export { ForwardRef as ReactComponent };